module.exports = __webpack_public_path__ + "static/media/section_2_icon_2.3ae73b34.png";